/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormikValues, FormikProps } from 'formik'

export type TFormErrors = {
  [field: string]: {
    value: any
    message: string
  }
}

export type TFormErrorColor = 'red'

export interface IFormControl extends FormikProps<FormikValues> {
  errors: TFormErrors
  errorColor: TFormErrorColor
  handleSubmit: () => any
}

export const FormEvaluate = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  void: (): void => {},
  height: {
    height: '100%',
  },
}
